import { AnalyticsService, MortgageInterestRateService } from '@io/services';

import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ModalContent } from '@ap/modal';
import { LoanToValueResponse } from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';
import { ApFormService } from '@ap/form';
import { ApContentPipe } from '@ap/content';
import { ApAmountInputComponent } from '@ap/input/amount';
import { ApButtonComponent, ApSubmitTextComponent } from '@ap/button';

@Component({
    selector: 'ltv-modal',
    standalone: true,
    imports: [ApContentPipe, ApAmountInputComponent, ApButtonComponent, ApSubmitTextComponent, ReactiveFormsModule],
    templateUrl: './ltv-modal.component.html'
})
export class LtvModalComponent extends ModalContent<any> implements OnInit {
    private readonly formService = inject(ApFormService);
    private readonly mortgageInterestRateService = inject(MortgageInterestRateService);
    private readonly analyticsService = inject(AnalyticsService);

    form: FormGroup;
    isLoading = false;
    min = 1;
    max = 9999999;

    get mortgageControl() {
        return this.form.controls.mortgage as FormControl<any>;
    }

    get purchasePriceControl() {
        return this.form.controls.purchasePrice as FormControl<any>;
    }

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.form = new FormGroup<{
            mortgage: FormControl;
            purchasePrice: FormControl;
        }>({
            mortgage: new FormControl(null, [Validators.required, Validators.min(this.min), Validators.max(this.max)]),
            purchasePrice: new FormControl(null, [Validators.required, Validators.min(this.min), Validators.max(this.max)])
        });
    }

    submit(): void {
        this.formService.verify(this.form);
        if (this.form.valid) {
            this.isLoading = true;
            this.mortgageInterestRateService
                .postLoanToValue(this.form.controls.mortgage.value, this.form.controls.purchasePrice.value)
                .subscribe({
                    next: (response: LoanToValueResponse) => {
                        this.sendAnalytics();
                        this.accept(response.loan_to_value);
                    },
                    error: () => this.decline(),
                    complete: () => (this.isLoading = false)
                });
        }
    }

    private sendAnalytics(): void {
        this.analyticsService.sendLtvCalculation(this.form.controls.mortgage.value, this.form.controls.purchasePrice.value);
    }
}
